import STRINGS from "./strings";
export const emptyStateDefault = {
  actionElement: null,
  alignContent: "center",
  emptyStateHeader: null,
  message: STRINGS.noResults,
  messageId: "message-id",
  noIllustration: false
};